import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const SyncIcon = (props: IconProps) => (
  <Icon w="20px" h="20px" viewBox="0 0 20 20" {...props}>
    <path d="M9.99992 3.33331V.833313L6.66659 4.16665l3.33333 3.33333v-2.5c2.75838 0 4.99998 2.24167 4.99998 5 0 .84162-.2083 1.64162-.5833 2.33332l1.2167 1.2167c.65-1.025 1.0333-2.2417 1.0333-3.55002 0-3.68333-2.9833-6.66667-6.66668-6.66667Zm0 11.66669c-2.75833 0-5-2.2417-5-5.00002 0-.84167.20833-1.64167.58333-2.33333L4.36659 6.44998c-.65 1.025-1.03334 2.24167-1.03334 3.55 0 3.68332 2.98334 6.66662 6.66667 6.66662v2.5l3.33338-3.3333L9.99992 12.5V15Z" />
  </Icon>
);

export default memo(SyncIcon);
